import { Button } from 'antd';
import styled, { css } from 'styled-components';
import { themecolor } from '../config.js';
import SimpleBar from 'simplebar-react';
import Sider from 'antd/es/layout/Sider.js';


const StyledCollapsedButton = styled(Button)`
    height: 30px;
    width: 30px;
    padding: 2px;
    position: absolute;
    background: ${({ theme }) => theme.components.Menu.itemBg};
    border: 1px solid;
    border-color: ${({ theme }) => theme.token.colorBorder};

     /* RTL Styles */
      ${({ theme }) =>
      theme.direction === 'rtl' &&
      css`
        left: -14px;
        `}
      /* LTR Styles */
      ${({ theme }) =>
      theme.direction !== 'rtl' &&
      css`
        right: -14px;~
      `}
    `;

const StyleSimpleBar = styled(SimpleBar)`
    flex: 1;
    min-height: 0;
    padding-bottom: 20px;
  `;

const StyleBrandLogo = styled.div`
  background-color:  ${({ theme }) => theme.components.Menu.itemBg};
  display: flex;
  align-items: center;
  height: calc(${themecolor.token.controlHeight}px * 2);
  padding-inline: 14px;
  line-height: 81px;
  justify-content: center;
`;

const StyleSider = styled(Sider)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index:1000;
  border-right: 1px solid ${({ theme }) => theme.components.Menu.menuBorderColor};
  background: ${({ theme }) => theme.components.Menu.itemBg};

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .demo-logo {
    .brand-sm-logo {
      display: none;
    }
  }

  .ant-menu-sub {
    .ant-menu-item {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .ant-menu-inline {
    border-inline-end: none !important;
  }

  &.ant-layout-sider-collapsed {
    .demo-logo {
      .brand-dark-logo {
          display: none;
      }

      .brand-sm-logo {
          display: inline-block;
      }
    }

    .ant-menu-item-group-title {
      text-align: center;
    }

  }

  .ant-menu-inline-collapsed {
    width: 100px;
  }
`;

const StyleSidebarFooter = styled.div`
  border-top: 1px solid ${({ theme }) => theme.components.Menu.menuBorderColor};
  background: ${({ theme }) => theme.components.Menu.itemBg};
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .sidebar-user {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: ${({ theme }) => theme.token.colorText};
    overflow: hidden;
    flex: 1;
    min-width: 0;
  }

  .sidebar-user-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sidebar-theme-toggle {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${({ theme }) => theme.token.colorText};
  }

  &.collapsed {
    justify-content: center;
    padding: 12px 0;

    .sidebar-user-name {
      display: none;
    }

    .sidebar-user {
      flex: 0 0 auto;
      justify-content: center;
    }
  }
`;


export { StyledCollapsedButton, StyleSimpleBar, StyleBrandLogo, StyleSider, StyleSidebarFooter };
